// extracted by mini-css-extract-plugin
module.exports = {"inner":"EditorFooter_inner__2JujK","errorLogs":"EditorFooter_errorLogs__2V8MF"};